export default {
  experimentId: '55',
  serverUrl: 'https://magpie-cogsciprag.fly.dev',
  socketUrl: 'wss://magpie-cogsciprag.fly.dev/socket',
  completionUrl: 'https://app.prolific.com/submissions/complete?cc=CVZ2ZGX8',
  contactEmail: 'test@random.com',
  // Either 'debug', 'directLink' or 'prolific'
  mode: 'debug',
  language: 'en'
};
